
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Website, WebsiteComposite } from '@/services/Website/interfaces';

export interface VhostManagePhp {
  version: string;
}

export interface VhostManageVhost {
  id: number;
  aliases?: string[];
  php?: VhostManagePhp;
}

export interface VhostManageData {
  vhost?: VhostManageVhost;
  phpVersions?: string[];
  vhostError?: string;
}

@Component
export default class VhostManagePanel extends Vue {
  @Prop({ type: Object, required: true })
  public composite!: WebsiteComposite;

  @Prop({ type: Boolean, default: false })
  public busy!: boolean;

  @Prop({ type: String, default: '' })
  public errorMessage!: string;

  @Prop({ type: Object, default: () => ({}) })
  public panelData!: VhostManageData;

  public updateFormValid: boolean = false;

  public aliasesInput: string = '';

  public phpVersion: string = '';

  public created(): void {
    this.resetFromData();
  }

  @Watch('data')
  public onDataChange(): void {
    this.resetFromData();
  }

  public get website(): Website {
    return this.composite.website;
  }

  public get vhost(): VhostManageVhost | null {
    return (this.panelData && this.panelData.vhost) || null;
  }

  public get phpVersions(): string[] {
    return (this.panelData && this.panelData.phpVersions) || [];
  }

  public resetFromData(): void {
    const vhost = this.panelData && this.panelData.vhost;
    this.aliasesInput = vhost && vhost.aliases ? vhost.aliases.join(', ') : '';
    this.phpVersion = (vhost && vhost.php && vhost.php.version) || this.phpVersions[0] || '';
  }

  public submitUpdate(): void {
    const aliases = this.aliasesInput
      .split(',')
      .map((alias) => alias.trim())
      .filter((alias) => !!alias);

    this.emitSubmit('update', {
      aliases,
      phpVersion: this.phpVersion,
    });
  }

  public emitSubmit(operation: string, payload: Record<string, unknown> = {}): void {
    this.$emit('submit', { operation, ...payload });
  }
}
